__turbopack_context__.v({
  "response": "McpToolsTabs-module__ypOsja__response",
  "tool": "McpToolsTabs-module__ypOsja__tool",
  "toolLabel": "McpToolsTabs-module__ypOsja__toolLabel",
  "tools": "McpToolsTabs-module__ypOsja__tools",
});
